import script from "./ModalNuevoPedido.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalNuevoPedido.vue?vue&type=script&setup=true&lang=js"

import "./ModalNuevoPedido.vue?vue&type=style&index=0&id=1d8a1ca3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d8a1ca3"]])

export default __exports__